import { LoaderSimpleIcon } from 'qw-ui-lib-v2/icons';

export default function Loader(props) {
  const size = props.size || 50;
  return (
    <LoaderSimpleIcon
      className="ui-loader"
      width={size}
      height={size}
      {...props}
    />
  );
}
